import type { Product } from './types'

export function homeRecommendedProducts(products: Product[]) {
  return products
    .filter((product) => Number(product.recommended || 0) === 1)
    .sort((left, right) => Number(left.recommendSort || 0) - Number(right.recommendSort || 0))
}
